import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from '@src/app/_redux';
import '../update-payment.scss';
import { PaymentMethod, PaymentAccount } from '@CDSGlobal/gc-backend';
import { Container, Row, Col } from 'reactstrap';
import { getPaymentMethodsRegular, getPaymentMethodsNeedsAttention } from '@src/app/accounts/selectors';
import { actionCreators } from '@src/app/accounts/updatepayment/actions';
import { bindActionCreators, Dispatch } from 'redux';
import { UpdatePaymentPayload } from '@src/_api/payload/update-payment';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { LoadingView } from '@src/app/_global/components/Loading';
import { ResponseView } from '@src/app/accounts/updatepayment/components/ResponseView';
import { getBillingAgreementIdFromPaymentCaptureResponse, 
         translatePaymentCaptureCardTypeToCore, 
         translatePaymentCapturePaymentTypeToCoreAlternatePaymentType, 
         translatePaymentCapturePaymentTypeToCorePaymentType } from '../../payment-methods/paymentUtils';
import { ALT_PAY_TYPES } from '@src/app/_global/utility/constants';
export interface UpdatePaymentProps {
  paymentMethodsRegularList: [];
  paymentMethodsNeedAttentionList: [];
  adminConfig: any;
  clientConfig: any;
  handleChange: any;
  handleSubmit: any;
  handleCancel: any;
  updatePaymentStart: any;
  coreUpdatePaymentStart: any;
  updatePaymentCancel: any;
  updatePaymentData: any;
  customers: any;
}

export class UpdatePaymentView extends Component<UpdatePaymentProps> {
  state: any = {
    widgetOpen: false,
    selectedPaymentMethod: {},
    displayError: '',
    showSubmitButton: false,
    selectedCustomer: null,
  };

  paymentCapture: any;

  constructor(props: any) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleSubmitButton = this.toggleSubmitButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmitRequest = this.onSubmitRequest.bind(this);
    this.updatePaymentDetails = this.updatePaymentDetails.bind(this);
    this.handleAltPmtAuth = this.handleAltPmtAuth.bind(this);
  }
  componentDidMount() {
    this.props.updatePaymentCancel();
    let availableActions = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'AvailableActions',
      this.props.clientConfig.clientConfig.magCode
    );
    let widgetId = (availableActions.Preferences && availableActions.Preferences.updatePaymentPaymentWidgetConfigId ? 
                    availableActions.Preferences.updatePaymentPaymentWidgetConfigId : '');
    const config =             {
      configId:  widgetId,
      origin: window.location.origin,
      prodIdAlias: this.props.customers[0].systemCode === 'CORE' ? this.props.customers[0].prodIdAlias : this.props.clientConfig.clientConfig.magCode,
      isCore: this.props.customers[0].systemCode === 'CORE',
    };
    this.paymentCapture = new PaymentCapture(config);
    this.paymentCapture.on('form-validated', this.toggleSubmitButton);
    this.paymentCapture.on('transaction-completed', this.handlePaymentSuccess);
    this.paymentCapture.on('alt-payment-authorized', this.handleAltPmtAuth);
  }

  handlePaymentSuccess = (data) => {
    this.handleSubmit(data);
  }
  getCCIcon(payment: any) {
    switch (payment.fullCreditCardType) {
      case'Visa':
        return 'fa fa-cc-visa fa-2x  cc-icon';
      case'Mastercard':
        return 'fa fa-cc-mastercard fa-2x cc-icon';
      case'Discover':
        return 'fa fa-cc-discover fa-2x cc-icon';
      case'American Express':
        return 'fa fa-cc-amex fa-2x cc-icon';
      case'Diners Club':
        return 'fa fa-cc-diners-club fa-2x cc-icon';
      case'PayPal':
        return 'fa fa-cc-paypal fa-2x cc-icon';
      case'Amazon Pay':
        return 'fa fa-amazon fa-2x cc-icon';
      case'Apple Pay':
        return 'fa fa-apple fa-2x cc-icon';
      default:
        return 'fa fa-credit-card fa-2x cc-icon';
    }
  }
  toggleSubmitButton(valid: any) {
    this.setState({
      showSubmitButton: valid
    });
  }

  handleAltPmtAuth(data: any) {
    if (data.pwRespMessage === 'Success') {
      this.setState({
        showSubmitButton: true
      });
    }
  }

  toggle(pmt: any) {
    let availableActions = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'AvailableActions',
      pmt.associatedAccounts[0].prodIdAlias
    );
    let widgetId = (availableActions.Preferences && availableActions.Preferences.updatePaymentPaymentWidgetConfigId ? 
                    availableActions.Preferences.updatePaymentPaymentWidgetConfigId : '');
    const config =             {
      configId:  widgetId,
      origin: window.location.origin,
      prodIdAlias: pmt.associatedAccounts[0].systemCode === 'CORE' ? this.props.customers[0].prodIdAlias : pmt.associatedAccounts[0].prodIdAlias,
      isCore: pmt.associatedAccounts[0].systemCode === 'CORE',
    };
    this.paymentCapture = new PaymentCapture(config);
    this.paymentCapture.on('form-validated', this.toggleSubmitButton);
    this.paymentCapture.on('ready', this.updatePaymentDetails);
    this.paymentCapture.on('transaction-completed', this.handlePaymentSuccess);
    this.paymentCapture.on('alt-payment-authorized', this.handleAltPmtAuth);

    let customer = this.findSelectedCustomer(pmt.associatedAccounts[0]);
    this.setState({
      widgetOpen: true,
      selectedPaymentMethod: pmt,
      displayError: '',
      showSubmitButton: false,
      selectedCustomer: customer,
    });
  }

  findSelectedCustomer(associatedAccount: any) {
    if (associatedAccount.systemCode === 'CORE') {
      return this.props.customers[0];
    } else {
      let selectedProdIdAlias = associatedAccount.prodIdAlias;
      let selectedCustomer = this.props.customers.find((cust: any) => {
        return cust.prodIdAlias === selectedProdIdAlias;
      });
      // SERV/Pf orders can be for different product line than the customer, so just match on client code if customer is not found. 
      if (!selectedCustomer) {
        selectedCustomer =  this.props.customers.find(customer => { 
          return customer.prodIdAlias.substring(0, 3) === selectedProdIdAlias.substring(0, 3); 
        });
      }
      return selectedCustomer;
    }
  }

  async onSubmitRequest(values: any) {
    values.preventDefault();
    this.setState({showSubmitButton: false});
    this.paymentCapture.performTransaction()
    .catch((error) => {
      console.log('GC-PC performTransactionError responseCode: ' + error.pwRespCode  + ' msg: ' + error.pwRespDescription );
    });
  }
  async updatePaymentDetails() {
    let generatedAuthorizationReferenceId = this.state.selectedCustomer.accountNumber + '-' + new Date().valueOf();
    let transCurrencyCode = this.state.selectedPaymentMethod && this.state.selectedCustomer.systemCode === 'CORE' ? 
                            (this.state.selectedPaymentMethod.currencyCode === 'CAD' ? '124' : '840') : '840'; // default to US $?
    await this.paymentCapture.updatePaymentDetails({
      countryCode: this.state.selectedCustomer.address.countryCode,
      transCurrencyCode: transCurrencyCode, 
      transAmount: '100',
      creditCard: {
        billingPostalCode: this.state.selectedCustomer.address.postalCode,
        billingAddressLine1:  this.state.selectedCustomer.address.address1,
        billingState:  this.state.selectedCustomer.address.state,
        billingCity:  this.state.selectedCustomer.address.city,
        cardHolderName:  this.state.selectedCustomer.address.name
      },
      altpayment: {
        customAuthorizationReferenceId: generatedAuthorizationReferenceId
      }
    }).catch((errors) => {
        console.log('PC processPayment Error: ' + JSON.stringify(errors));
    });
  }
  handleCancel() {
    this.setState({
      widgetOpen: false,
      selectedPaymentMethod: {},
      displayError: '',
      showSubmitButton: false,
      selectedCustomer: null,
    });
    let pageIntroTable = getAdminConfigTableItem(
      this.props.adminConfig,
      this.props.clientConfig,
      'PageIntro',
    );
    let pageIntro;
    if (pageIntroTable.PageIntroductions) {
      pageIntro = pageIntroTable.PageIntroductions.find(intro => {
        return intro.route === 'updatepayment';
      });
    }
    let pageIntroDescHtml = document.getElementsByClassName('page-intro-desc') || null;
    if (pageIntroDescHtml && pageIntroDescHtml.length > 0) {
      pageIntroDescHtml[0].innerHTML = pageIntro ?  pageIntro.description  : '';
    }
    let pageIntroLabelHtml = document.getElementsByClassName('page-intro-label') || null;
    if (pageIntroLabelHtml && pageIntroLabelHtml.length > 0) {
      pageIntroLabelHtml[0].innerHTML = pageIntro ? pageIntro.label  : '';
    }
    this.props.updatePaymentCancel();
  }

  handleSubmit(response: any) {
    let responseMessage = response.pwRespMessage;
    let currPmt = this.state.selectedPaymentMethod;
    let payloads: Array<UpdatePaymentPayload> = [];
    let updatePaymentPayload: UpdatePaymentPayload = {
      systemCode: '',
      prodIdAlias: '',
      productName: '',
      accountNumber: '',
      recipAccountNumber: '',
      planCode: '',
      updateType: 'updatePayMethod',
      orderType: '',
      creditCardExpireMonth: '',
      creditCardExpireYear: '',
      creditCardType: '',
      creditCardNumber: '',
      shipFrequency: '',
      googleAnalyticsCategory: '',
      transactionNumber: '',
      creditCardLastFour: '',
    };
    if (responseMessage === 'Success') {
      let expMM = response.pwResponse.creditCardExpireMonth;
      let expYY = response.pwResponse.creditCardExpireYear;
      let cardType = response.pwResponse.creditCardType;
      let creditCardLastFour = response.pwResponse.creditCardLastFour;
      let cipher = response.pwResponse.token;
      let paymentType = response.pwPaymentType;
      let corePayloadCreated = false;
      currPmt.associatedAccounts.map((assocAcctInfo) => {
        switch (assocAcctInfo.systemCode) {
          case 'SERV':
            updatePaymentPayload = {
              systemCode: assocAcctInfo.systemCode,
              prodIdAlias: assocAcctInfo.prodIdAlias,
              productName: assocAcctInfo.productName,
              accountNumber: assocAcctInfo.accountNumber,
              name: assocAcctInfo.name,
              creditCardExpireMonth: expMM,
              creditCardExpireYear: expYY,
              creditCardType: cardType,
              creditCardNumber: cipher,
              oldCreditCardExpireMonth: currPmt.creditCardExpireMonth,
              oldCreditCardExpireYear: currPmt.creditCardExpireYear.substring(currPmt.creditCardExpireYear.length - 2, currPmt.creditCardExpireYear.length),
              oldCreditCardNumber: currPmt.creditCardNumber,
              oldCreditCardType: currPmt.creditCardType,
              googleAnalyticsCategory:  'Update Payment Method',
              transactionNumber: assocAcctInfo.transactionNbr,
              creditCardLastFour: creditCardLastFour,
            };
            payloads.push(updatePaymentPayload);
            break;
          case 'EHUB':
            updatePaymentPayload = {
              systemCode: assocAcctInfo.systemCode,
              prodIdAlias: assocAcctInfo.prodIdAlias,
              productName: assocAcctInfo.productName,
              accountNumber: assocAcctInfo.accountNumber,
              name: assocAcctInfo.name,
              creditCardExpireMonth: expMM,
              creditCardExpireYear: expYY,
              creditCardType: cardType,
              creditCardNumber: cipher,
              cardProfileId: assocAcctInfo.cardProfileId,
              creditCardLastFour: creditCardLastFour,
              googleAnalyticsCategory: 'Update Payment Method'
            };
            payloads.push(updatePaymentPayload);
            break;
          case 'SERVPF':
            updatePaymentPayload = {
              systemCode: assocAcctInfo.systemCode,
              prodIdAlias: assocAcctInfo.prodIdAlias,
              productName: assocAcctInfo.productName,
              accountNumber: assocAcctInfo.accountNumber,
              recipAccountNumber: assocAcctInfo.recipAccountNumber ? assocAcctInfo.recipAccountNumber : '',
              planCode: assocAcctInfo.planCode ? assocAcctInfo.planCode : '',
              updateType: 'updatePayMethod',
              orderType: cipher ? 'C' : 'B',
              creditCardExpireMonth: expMM,
              creditCardExpireYear: expYY,
              creditCardType: cardType,
              creditCardNumber: cipher,
              shipFrequency: assocAcctInfo.frequency,
              creditCardLastFour: creditCardLastFour,
              googleAnalyticsCategory: 'Update Series - Change Payment Method',
            };
            payloads.push(updatePaymentPayload);
            break;
          case 'CORE':
            if (!corePayloadCreated) {
              corePayloadCreated = true;
              let entityIds: [{entityId: string, entityType: string, productName: string, googleAnalyticsLabel: string}] = currPmt.associatedAccounts
                .filter(coreAssocAcctInfo => coreAssocAcctInfo.systemCode === 'CORE')
                .map(account => {
                  return { entityId: account.entityId, 
                           entityType: account.entityType, 
                           productName: account.productName,
                           googleAnalyticsLabel: account.prodIdAlias 
                  };
              });               
              updatePaymentPayload = {
                prodIdAlias: this.state.selectedCustomer.prodIdAlias,
                accountNumber: assocAcctInfo.accountNumber,
                paymentType: translatePaymentCapturePaymentTypeToCorePaymentType(paymentType),
                billingOrganizationCode: currPmt.billingOrganizationCode,
                creditCardNumber: cipher,
                creditCardType: translatePaymentCaptureCardTypeToCore(cardType),
                creditCardExpireMonth: expMM,
                creditCardExpireYear: expYY,
                creditCardLastFour: creditCardLastFour,
                currencyCode: currPmt.currencyCode,
                systemCode: assocAcctInfo.systemCode,
                productName: assocAcctInfo.productName,
                googleAnalyticsCategory: 'Update Payment Method',
                googleAnalyticsLabel: assocAcctInfo.prodIdAlias, 
                entityIds: entityIds
              };
              if (paymentType in ALT_PAY_TYPES) {
                if (paymentType === 'AP') {
                  updatePaymentPayload.digitalPaymentType = 'Apple Pay';
                } else {
                  updatePaymentPayload.alternatePaymentType = translatePaymentCapturePaymentTypeToCoreAlternatePaymentType(paymentType);
                  updatePaymentPayload.billingAgreementId = getBillingAgreementIdFromPaymentCaptureResponse(response);
                }
              }
              payloads.push(updatePaymentPayload);
            }
            break;
          default: 
            break;
        }
      });
      if (corePayloadCreated) {
        this.props.coreUpdatePaymentStart(payloads);
      } else {
        this.props.updatePaymentStart(payloads);
      }
    } else {
      this.setState({ displayError: 'An error has occurred. Please try again.', }); 
    }
  }
  
  deDupeProductNames(associatedAccounts: PaymentAccount[]): any {
    if (associatedAccounts) {
      let prodNames: Array<{ value: string }> = [];
      associatedAccounts.forEach(account => {
        if (prodNames.filter(item => item.value === account.productName).length === 0) {
          prodNames.push({
            value: account.productName
          });
        }
      });
      return prodNames;
    }
  }

  render() {
    const { paymentMethodsRegularList, paymentMethodsNeedAttentionList, updatePaymentData } = this.props;
    return (
      <div>
        { updatePaymentData.loading ? (
          <LoadingView loadingText="Loading..."/>
        ) : (
          updatePaymentData.updatePaymentResult !== null ? (
          <ResponseView
            onExit={this.handleCancel}
            updatePaymentData={updatePaymentData}
            adminConfig={this.props.adminConfig}
            clientConfig={this.props.clientConfig}
          />
          ) : (
            <Container className="pb-3 update-payment-view " fluid={true}>             
              { paymentMethodsNeedAttentionList && paymentMethodsNeedAttentionList.length ? 
                <div>
                  <Row className="mb-2"> 
                    <Col  xs={12} sm={12} md={12} className="section-title">
                      <i className="fa fa-exclamation-triangle title fa-2x"></i><span className="payment-type ml-1">Payment Methods Needing Attention</span>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={12} sm={12} md={6}>
                      {paymentMethodsNeedAttentionList.map((pmt: PaymentMethod) => {
                        return (
                          <div key={`${pmt.id}-pmtNeedsAttention-${pmt.currencyCode}`} className="payment-item">
                            <div className="mb-2" key={`${pmt.id}-payments`}>
                              <div key={pmt.id}>
                                <i className={this.getCCIcon(pmt)}></i> 
                                <span className="ml-2 pb-2"> 
                                  {pmt.fullCreditCardType} 
                                  {!pmt.isAltPayType ? ` ending in ${pmt.creditCardNumber} expires ${pmt.creditCardExpireMonth}/${pmt.creditCardExpireYear}` : ''}
                                </span>
                                {(!this.state.selectedPaymentMethod.id || pmt.id === this.state.selectedPaymentMethod.id) && 
                                  <i className="fa pointer fa-pencil ml-4 fa-2x"  onClick={() => this.toggle(pmt)}></i>
                                }
                              </div>
                            </div>
                            <div key={`${pmt.id}-products`}>
                              <div key={pmt.id} className="">
                                {this.deDupeProductNames(pmt.associatedAccounts).map((acct) => {
                                  return (<div key={`${pmt.id}-${acct.value}`}>{acct.value}</div>);
                                })}
                              </div>
                            </div>
                          </div>
                        );
                      }
                      )}
                    </Col>
                  </Row>    
                </div>
              : ''}
              { paymentMethodsRegularList && paymentMethodsRegularList.length ? 
              <Container className="pb-3 update-payment-view " fluid={true}>
                <Row className="mb-2">
                  <Col xs={12} sm={12} md={12} className="section-title">
                    <span className="payment-type">Payment Methods </span>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={12} sm={12} md={6}>
                    {paymentMethodsRegularList.map((pmt: PaymentMethod) => {
                      return (
                        <div key={`${pmt.id}-pmtReg-${pmt.currencyCode}`} className="payment-item">
                          <div className="mb-2" key={`${pmt.id}-payments`}>
                            <div key={pmt.id}>
                              <i className={this.getCCIcon(pmt)}></i> 
                              <span className="ml-2 pb-2"> 
                                {pmt.fullCreditCardType}
                                {!pmt.isAltPayType ? ` ending in ${pmt.creditCardNumber} expires ${pmt.creditCardExpireMonth}/${pmt.creditCardExpireYear}` : ''}
                              </span>
                              {(!this.state.selectedPaymentMethod.id || pmt.id === this.state.selectedPaymentMethod.id) && 
                                <i className="fa pointer fa-pencil ml-4 fa-2x"  onClick={() => this.toggle(pmt)}></i> 
                              }
                            </div>
                          </div>
                          <div key={`${pmt.id}-products`}>
                              {this.deDupeProductNames(pmt.associatedAccounts).map((acct) => {
                                return (<div key={`${pmt.id}-${acct.value}`}>{acct.value}</div>);
                              })}
                          </div>
                        </div>
                      );
                    }
                    )}
                  </Col>
                </Row>

              </Container>
            : ''}
            <Row className="payment-widget">
              <Col className={` ${this.state.widgetOpen ? '' : 'd-none'}`} xs={12} sm={12} md={6}>
              {this.state.displayError.length > 0 && (<span className="text-danger bold mt-3 mb-3">{this.state.displayError}</span>)}
                <div id="payment-capture"></div>  
                <div className="button-ct">
                  <button className="btn btn-primary " type="button" disabled={!this.state.showSubmitButton} onClick={this.onSubmitRequest}> Okay </button>
                  <button className="btn btn-light payment-widget-cancel" type="button" onClick={this.handleCancel}>Cancel </button>
                </div>                 
              </Col>
            </Row>
          </Container>
          )
        )} 
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  paymentMethodsNeedAttentionList: getPaymentMethodsNeedsAttention(state),
  paymentMethodsRegularList: getPaymentMethodsRegular(state),
  adminConfig: state.adminConfig,
  clientConfig: state.clientConfig,
  updatePaymentData: state.account.updatePaymentData,
  customers: state.account.customerData.customers,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      updatePaymentStart: actionCreators.updatePaymentStart,
      coreUpdatePaymentStart: actionCreators.coreUpdatePaymentStart,
      updatePaymentCancel: actionCreators.updatePaymentCancel
    },
    dispatch,
);
export const UpdatePayment = connect(
  mapStateToProps, mapDispatchToProps
)(UpdatePaymentView);
